import * as React from "react";

import "./address-selection-section.scss";

import {cs}            from "@Common/react/chain-services";
import {snv}           from "@Common/utils/arr-path";

import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faCircle}               from "@fortawesome/free-solid-svg-icons";
import {ExpandableStreetsTable} from "./expandable-streets-table/expandable-streets-table";

export const AddressSelectionSection = ({streets, addresses, view, next}) => cs(
    ["expandableStreetsTable", ({}, next) => ExpandableStreetsTable({streets, addresses, next})],
    ({expandableStreetsTable}) => next({
        getNextAction: ({onNext, loading, loadErrorHighlight}) => ({
                disabled: !expandableStreetsTable.containsAddresses || loading.value.loading || view.value === "search",
                action: () => {
                    if (loading.value.loading) {
                        loadErrorHighlight();
                    } else if(!expandableStreetsTable.containsAddresses) {
                        expandableStreetsTable.highlightErrors();
                    } else if(view.value !== "search") {
                        onNext();
                    }
                },
        }),
        createRequestData: async () => ({
            ...streets.value,

            streets: await (async () => {
                let streetsData = streets.value.streets;
                for (const streetName of Object.keys(streetsData)) {
                    streetsData = snv(
                        streetsData, [streetName, "IndividualAddresses"],
                        addresses.value[streetName],
                    );
                }

                return streetsData;
            })(),
        }),
        render: ({target}) => (
            <div className="address-selection-section-j87">
                <div className="prev-section">
                    <div className="title" xd-qa-name="Build Radius List Target Area" xd-qa-type="label">
                        Target Area
                    </div>
                    <a
                        className="edit"
                        xd-qa-name="Build Radius List Edit"
                        xd-qa-type="link"
                        onClick={() => view.onChange("search")}
                    >
                        Edit
                    </a>
                    <div className="sub-title" xd-qa-name="Build Radius List Target Area Description" xd-qa-type="label">
                        {target.address.toUpperCase()} <FontAwesomeIcon icon={faCircle}/> ZIP: {target.zip} <FontAwesomeIcon icon={faCircle}/> QTY: {target.quantity}
                    </div>
                </div>
                <div className="header">
                    <div className="left">
                        <div className="title" xd-qa-name="Build Radius List Addresses" xd-qa-type="label">Addresses</div>
                        <div
                            className="sub-title"
                            xd-qa-name="Build Radius List Addresses Description"
                            xd-qa-type="label"
                        >
                            Uncheck the streets you wish to remove from the list.
                        </div>
                    </div>
                    <div className="right">
                        {expandableStreetsTable.renderSearch()}
                    </div>
                </div>
                <div className="box">
                    {expandableStreetsTable.render()}
                </div>
            </div>
        ),
    })
);